<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Materiality</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAuditMaterialityCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAuditMateriality()">
        <mat-icon>add</mat-icon>
        Add Materiality
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditMaterialities()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditMateriality($event)"
      (deleteClick)="onDeleteAuditMateriality($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
